import { combineReducers } from "@reduxjs/toolkit";

//Project imports
import AuthenticationData from "./authReducer";
import { RightSideBtn, BlockReducer } from "./blockReducer";
export default combineReducers({
    AuthenticationData,
    RightSideBtn,
    BlockReducer
  });